module.exports = __webpack_public_path__ + "img/wf.c43a77de.svg";